<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Document No. Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm3>
            <v-text-field append-icon="mdi-magnify" label="Document No" single-line hide-details v-model="docNo"></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field append-icon="mdi-magnify" label="Payee Name" single-line hide-details v-model="name"></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text style="max-height: 600px; overflow-y: auto">
        <v-card>
          <v-data-table
            v-bind:headers="headers"
            v-bind:items="items"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="docNo"
            :loading="loading"
            :server-items-length="totalItems"
            :no-data-text="noDataText"
            v-model="selected"
          >
            <template v-slot:item="row"
              ><tr>
                <td width="50px">
                  <input type="checkbox" primary hide-details v-model="row.selected" @click="selectData(row.item)" />
                </td>
                <td class="text-xs-left">{{ row.item.branch }}</td>
                <td class="text-xs-left">{{ row.item.tranType }}</td>
                <td class="text-xs-left">{{ row.item.docNo }}</td>
                <td class="text-xs-left">{{ row.item.namePayee }}</td>
              </tr></template
            >
          </v-data-table>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">
          Cancel
          <v-icon dark right>mdi-cancel</v-icon></v-btn
        >
        <v-btn color="primary" dark class=" mr-2" @click="doSelect">
          Select
          <v-icon right>mdi-arrow-right-bold-circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      docNo: undefined,
      name: undefined,
      headers: [
        { text: '', value: 'checkbox' },
        { text: 'Branch', value: 'branch' },
        { text: 'Tran Type ', value: 'tranType' },
        { text: 'Document No.', value: 'docNo' },
        { text: 'Name of Payee', value: 'namePayee' }
      ],
      totalItems: 0,
      selected: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.rptMenu.claimDoc
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            // return as a menu list
            this.menu = extractMenu(result.data._links)
            if (this.menu) {
              this.doFetchDocNo()
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doFetchDocNo() {
      const apiURI = this.menu.getDocNoList
      if (apiURI) {
        this.loading = true
        const currFilters = {
          branch: this.brn,
          dept: this.dept,
          docNo: this.docNo,
          name: this.name,
          tranType: this.tranType
        }
        const { page, itemsPerPage } = this.pagination
        let expand = {
          page: page - 1,
          size: itemsPerPage,
          options: {}
        }
        try {
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          this.docNoItem = []
          const { data } = result.data
          if (data) {
            this.totalItems = data.totalItems
            data.docNoList.map((docNoList) => {
              const convertList = {
                branch: docNoList.branch,
                tranType: docNoList.tranType,
                docNo: docNoList.docNo,
                namePayee: docNoList.namePayee
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    },
    doSelect() {
      const selectedItems = []
      selectedItems.push(this.selected[0].docNo)
      const docNoObj = {
        selectedItems: selectedItems,
        totalLength: this.items.length,
        from: 'docNo'
      }
      this.$emit('doAssign', docNoObj)
      this.$emit('close')
    },
    selectData(data) {
      this.selected = []
      const resultList = {
        branch: data.branch,
        tranType: data.tranType,
        docNo: data.docNo,
        namePayee: data.namePayee
      }
      this.selected.push(resultList)
    },
    doCancel() {
      this.$emit('close')
    }
  },
  watch: {
    docNo: function (value) {
      this.doFetchDocNo()
    },
    name: function (value) {
      this.doFetchDocNo()
    },
    'pagination': function (value) {
      this.doFetchDocNo()
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    brn: {
      type: String,
      default: ''
    },
    dept: {
      type: String,
      default: ''
    },
    tranType: {
      type: String,
      default: ''
    }
  }
}
</script>
